import { creatorbase, influencer, TiktokUser, TiktokUserStatsCache } from '@round/api';
import { getTiktokEngagementRate } from 'Modules/Plans/Posts/helpers';
import { CampaignTableRow } from '../../../Project/ProjectDetails/components/ProjectCampaignsTable/ProjectCampaignsTable';
import { Row, Totals } from './TiktokReportClipboardTable';
import { isNumber } from 'utility/utility';

type MapToClipboardReportRowParams = {
    post: creatorbase.TiktokPost | creatorbase.PublicTiktokPost;
    user?: TiktokUser | null;
    userStats?: TiktokUserStatsCache | null;
};

export const mapToClipboardReportRow = ({ post, user, userStats }: MapToClipboardReportRowParams): Row => {
    return {
        status: post.status,
        cost: post.cost,
        views: post.view_count,
        likes: post.tiktok_details?.like_count,
        comments: post.tiktok_details?.comment_count,
        shares: post.tiktok_details?.share_count,
        saves: post.tiktok_details?.save_count,
        username: user?.unique_id,
        followers: userStats?.follower_count,
        link: post.post_url,
        engagementRate: getTiktokEngagementRate(post),
        uploadDate: post.upload_date,
    };
};

export const mapToClipboardReportTotals = (
    posts: Row[],
    stats?: creatorbase.AggregatedPostStats | influencer.AggregatedPostStats | null,
    campaign?: creatorbase.Campaign | CampaignTableRow
): Totals => {
    return {
        cost:
            !campaign?.is_post_cost_editable && isNumber(campaign?.cost)
                ? campaign?.cost
                : posts.reduce((acc, post) => acc + (post.cost ?? 0), 0) ?? null,
        likes: posts.reduce((acc, post) => acc + (post.likes ?? 0), 0) ?? null,
        comments: posts.reduce((acc, post) => acc + (post.comments ?? 0), 0) ?? null,
        shares: posts.reduce((acc, post) => acc + (post.shares ?? 0), 0) ?? null,
        saves: posts.reduce((acc, post) => acc + (post.saves ?? 0), 0) ?? null,
        views: stats?.view_count,
        engagementRate: stats?.engagement_rate,
    };
};
